type IClassNameUnit = null | undefined | boolean | string | string[];
export type IClassName = IClassNameUnit | (IClassNameUnit | IClassName)[];
export const classNameFunc = (_class?: IClassName): string => {
    const __class = _class === undefined || _class === null ? [] : !Array.isArray(_class) ? [_class] : _class;
    return __class.map((e) => Array.isArray(e) ? classNameFunc(e) : e).map(e => typeof e === 'boolean' ? null : e !== null && e !== undefined ? e?.trim() : e).filter(e => ![null, undefined, ''].includes(e)).join(' ')
}